{
    "DataTable_AreYouSure": "Êtes-vous sûr de vouloir supprimer ce qui suit ? \n \n **{}**",
    "NAME": "LanguageDataTable"
}